import { ActionTree } from 'vuex';
import { MutationTree } from 'vuex';
import { GetterTree } from 'vuex';
import { Module } from 'vuex';

// export const defineVuexModule = <T, R>(module: Module<T, R>): typeof module => module;
export const defineVuexModule = <
  A,
  B extends GetterTree<A, {}>,
  C extends MutationTree<A>,
  D extends ActionTree<A, {}>,
  E extends Record<string, Module<any, any>>,
>(module: {
  state: A;
  getters: B;
  mutations: C;
  actions: D;
  modules?: E;
  namespaced?: boolean;
}): typeof module => module satisfies Module<A, {}>;
